import { connect } from 'react-redux';

import { getAccount, closeModal } from '../actions';
import { State } from '../../../reducer';
import { getAccountSelector, getShowWelcomeModalSelector } from '../selectors';
import { getExchangeTokenPartnerId } from '../../../auth/accessToken/selectors';

import Welcome from '../components/Welcome';

const mapStateToProps = (state: State) => ({
    account: getAccountSelector(state),
    showWelcomeModal: getShowWelcomeModalSelector(state),
    exchangeTokenPartnerId: getExchangeTokenPartnerId(state),
});

const mapDispatchToProps = {
    getAccount,
    closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
